import { DeviationResourceType, DeviationTypes } from '../../types/deviation';
import { CommentableTypes } from '../../Comment/redux/types';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { getDeviationTitle, getDeviationType, } from '../../DeviationViews/_helpers';
import get from 'lodash/get';
export function getCommentableTypeForDeviationType(deviationTypeId) {
    switch (deviationTypeId) {
        case DeviationResourceType.COMMISSION:
            return CommentableTypes.COMMENT_COMMISSION;
        case DeviationResourceType.POLL:
            return CommentableTypes.COMMENT_POLL_BLOG;
        case DeviationResourceType.STATUS:
            return CommentableTypes.COMMENT_STATUS;
        case DeviationResourceType.ART:
        case DeviationResourceType.JOURNAL:
        default:
            return CommentableTypes.COMMENT_DEVIATION;
    }
}
export function getDeviationTypeForCommentableType(commentableTypeId) {
    switch (commentableTypeId) {
        case CommentableTypes.COMMENT_COMMISSION:
            return DeviationResourceType.COMMISSION;
        case CommentableTypes.COMMENT_POLL_BLOG:
            return DeviationResourceType.POLL;
        case CommentableTypes.COMMENT_STATUS:
            return DeviationResourceType.STATUS;
        case CommentableTypes.COMMENT_DEVIATION:
            return DeviationResourceType.ART;
        default:
            return DeviationResourceType.UNKNOWN;
    }
}
export function getBiEventTypeForViewChange(currentViewMode, nextViewMode) {
    switch (nextViewMode) {
        case DeviationViewMode.Fullscreen:
            return BiEventType.FULLSCREEN_MODE;
        case DeviationViewMode.Theater:
            return BiEventType.THEATRE_MODE;
        default:
            if (currentViewMode === DeviationViewMode.Fullscreen) {
                return BiEventType.FULLSCREEN_MODE;
            }
            else {
                return BiEventType.THEATRE_MODE;
            }
    }
}
export function getBiEventComponentByType(deviationType) {
    switch (deviationType) {
        case DeviationTypes.COMMISSION:
            return 'commission';
        case DeviationTypes.STATUS:
            return 'status';
        case DeviationTypes.POLL:
            return 'poll';
        case DeviationTypes.JOURNAL:
            return 'journal';
        case DeviationTypes.TIER:
            return 'tier';
        default:
            return 'art';
    }
}
export function getPageTitle(deviation, t) {
    if (!deviation) {
        return t('deviation.page.title.unknown');
    }
    var deviationTitle = getDeviationTitle(deviation);
    var author = deviation.author;
    var isStatus = getDeviationType(deviation) === DeviationTypes.STATUS;
    if (!author || (!isStatus && !deviationTitle)) {
        return t('deviation.page.title.unknown');
    }
    if (isStatus) {
        return t('deviation.page.title.status', { author: author.username });
    }
    return t('deviation.page.title', {
        author: author.username,
        title: deviationTitle,
    });
}
export function getDeviationNotificationQueue(_a) {
    var deviationId = _a.deviationId, typeId = _a.typeId;
    return "deviation-".concat(typeId, "-").concat(deviationId);
}
export function isExtendedDeviationFullyLoaded(deviation) {
    return !!((deviation === null || deviation === void 0 ? void 0 : deviation.extended) && get(deviation, 'extended.isComplete', true));
}
export function getDeviationAppUrl(deviation) {
    var _a;
    var uuid = (_a = deviation === null || deviation === void 0 ? void 0 : deviation.extended) === null || _a === void 0 ? void 0 : _a.deviationUuid;
    if (!uuid) {
        return;
    }
    switch (getDeviationType(deviation)) {
        // special snowflake
        case DeviationTypes.STATUS:
            return "status/".concat(uuid);
        // unsupported types
        case DeviationTypes.COMMISSION:
        case DeviationTypes.POLL:
        case DeviationTypes.UNKNOWN:
            return;
        default:
            return "deviation/".concat(uuid);
    }
}
//# sourceMappingURL=helpers.js.map